import React from "react";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";

// The "Are you on the server?" confirmation every sync-software install goes through:
// the installer only works on the computer that runs the practice-management software.
const ServerConfirmationModal = ({ isOpen, onClose, onYes, onNo }) => (
  <Modal isOpen={isOpen} onClose={onClose} isCentered>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader
        bg="red.500"
        color="white"
        display="flex"
        alignItems="center"
        gap={2}
      >
        <WarningIcon />
        Important Confirmation
      </ModalHeader>
      <ModalCloseButton color="white" />
      <ModalBody>
        <Text mb={2} fontWeight="bold" color="red.600">
          For best results, run this from the <b>server</b> that hosts your
          practice-management software (not a workstation).
        </Text>
        <Text>Are you currently on that server?</Text>
      </ModalBody>
      <ModalFooter as={Flex} justify="flex-end" gap={4}>
        <Button variant="outline" colorScheme="red" onClick={onNo}>
          No, I’m on a workstation
        </Button>
        <Button colorScheme="red" onClick={onYes}>
          Yes, I’m on the server
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default ServerConfirmationModal;
